import { AdminProduct } from '../model/adminProduct';
import { AdminProductInfo } from '../model/adminProductInfo';
import { ProductBuilder } from './product-builder';
import { ImageGalleryBuilder } from "./image-gallery-builder";
export class AdminProductBuilder {
    static buildAdminProduct(data) {
        const adminProduct = new AdminProduct();
        adminProduct.id = data.id;
        adminProduct.id_rsys_1 = data.id_rsys_1;
        adminProduct.id_rsys_2 = data.id_rsys_2;
        adminProduct.id_rsys_3 = data.id_rsys_3;
        adminProduct.id_rsys_4 = data.id_rsys_4;
        adminProduct.id_key_zone = data.id_key_zone;
        adminProduct.id_lot = data.id_lot;
        adminProduct.carencia = data.carencia;
        adminProduct.dias_sin_carencia = data.dias_sin_carencia;
        adminProduct.day_hours = data.day_hours;
        adminProduct.free_time = data.free_time;
        adminProduct.rsys_ahead_hours = data.rsys_ahead_hours;
        adminProduct.ask_passengers = data.ask_passengers;
        adminProduct.name = data.name;
        adminProduct.name_short = data.name_short;
        adminProduct.official_parking_name = data.official_parking_name;
        adminProduct.openinghours_type = data.openinghours_type;
        adminProduct.open_hour = data.open_hour;
        adminProduct.open_minute = data.open_minute;
        adminProduct.close_hour = data.close_hour;
        adminProduct.close_minute = data.close_minute;
        adminProduct.season_product = data.season_product;
        adminProduct.long_stay_alternative_product_enabled = data.long_stay_alternative_product_enabled;
        adminProduct.long_stay_alternative_product_occupation_threshold = data.long_stay_alternative_product_occupation_threshold;
        adminProduct.long_stay_alternative_product_min_days = data.long_stay_alternative_product_min_days;
        adminProduct.long_stay_alternative_product_id = data.long_stay_alternative_product_id;
        adminProduct.season_start_day = data.season_start_day;
        adminProduct.season_start_month = data.season_start_month;
        adminProduct.season_end_day = data.season_end_day;
        adminProduct.season_end_month = data.season_end_month;
        adminProduct.t5_day_1 = data.t5_day_1;
        adminProduct.t4_day_1 = data.t4_day_1;
        adminProduct.t3_day_1 = data.t3_day_1;
        adminProduct.t2_day_1 = data.t2_day_1;
        adminProduct.t1_day_1 = data.t1_day_1;
        adminProduct.t5_day_2 = data.t5_day_2;
        adminProduct.t4_day_2 = data.t4_day_2;
        adminProduct.t3_day_2 = data.t3_day_2;
        adminProduct.t2_day_2 = data.t2_day_2;
        adminProduct.t1_day_2 = data.t1_day_2;
        adminProduct.t5_day_3 = data.t5_day_3;
        adminProduct.t4_day_3 = data.t4_day_3;
        adminProduct.t3_day_3 = data.t3_day_3;
        adminProduct.t2_day_3 = data.t2_day_3;
        adminProduct.t1_day_3 = data.t1_day_3;
        adminProduct.t5_day_4 = data.t5_day_4;
        adminProduct.t4_day_4 = data.t4_day_4;
        adminProduct.t3_day_4 = data.t3_day_4;
        adminProduct.t2_day_4 = data.t2_day_4;
        adminProduct.t1_day_4 = data.t1_day_4;
        adminProduct.t5_day_5 = data.t5_day_5;
        adminProduct.t4_day_5 = data.t4_day_5;
        adminProduct.t3_day_5 = data.t3_day_5;
        adminProduct.t2_day_5 = data.t2_day_5;
        adminProduct.t1_day_5 = data.t1_day_5;
        adminProduct.t5_day_6 = data.t5_day_6;
        adminProduct.t4_day_6 = data.t4_day_6;
        adminProduct.t3_day_6 = data.t3_day_6;
        adminProduct.t2_day_6 = data.t2_day_6;
        adminProduct.t1_day_6 = data.t1_day_6;
        adminProduct.t5_day_7 = data.t5_day_7;
        adminProduct.t4_day_7 = data.t4_day_7;
        adminProduct.t3_day_7 = data.t3_day_7;
        adminProduct.t2_day_7 = data.t2_day_7;
        adminProduct.t1_day_7 = data.t1_day_7;
        adminProduct.t5_day_8 = data.t5_day_8;
        adminProduct.t4_day_8 = data.t4_day_8;
        adminProduct.t3_day_8 = data.t3_day_8;
        adminProduct.t2_day_8 = data.t2_day_8;
        adminProduct.t1_day_8 = data.t1_day_8;
        adminProduct.t5_day_9 = data.t5_day_9;
        adminProduct.t4_day_9 = data.t4_day_9;
        adminProduct.t3_day_9 = data.t3_day_9;
        adminProduct.t2_day_9 = data.t2_day_9;
        adminProduct.t1_day_9 = data.t1_day_9;
        adminProduct.t5_day_10 = data.t5_day_10;
        adminProduct.t4_day_10 = data.t4_day_10;
        adminProduct.t3_day_10 = data.t3_day_10;
        adminProduct.t2_day_10 = data.t2_day_10;
        adminProduct.t1_day_10 = data.t1_day_10;
        adminProduct.t5_day_extra = data.t5_day_extra;
        adminProduct.t4_day_extra = data.t4_day_extra;
        adminProduct.t3_day_extra = data.t3_day_extra;
        adminProduct.t2_day_extra = data.t2_day_extra;
        adminProduct.t1_day_extra = data.t1_day_extra;
        adminProduct.t5_minute = data.t5_minute;
        adminProduct.t4_minute = data.t4_minute;
        adminProduct.t3_minute = data.t3_minute;
        adminProduct.t2_minute = data.t2_minute;
        adminProduct.t1_minute = data.t1_minute;
        adminProduct.t5_vat_rate = data.t5_vat_rate;
        adminProduct.t4_vat_rate = data.t4_vat_rate;
        adminProduct.t3_vat_rate = data.t3_vat_rate;
        adminProduct.t2_vat_rate = data.t2_vat_rate;
        adminProduct.t1_vat_rate = data.t1_vat_rate;
        adminProduct.t5_trans = data.t5_trans;
        adminProduct.t4_trans = data.t4_trans;
        adminProduct.t3_trans = data.t3_trans;
        adminProduct.t2_trans = data.t2_trans;
        adminProduct.t1_trans = data.t1_trans;
        adminProduct.t5_trans_rate = data.t5_trans_rate;
        adminProduct.t4_trans_rate = data.t4_trans_rate;
        adminProduct.t3_trans_rate = data.t3_trans_rate;
        adminProduct.t2_trans_rate = data.t2_trans_rate;
        adminProduct.t1_trans_rate = data.t1_trans_rate;
        adminProduct.t5_points = data.t5_points;
        adminProduct.t4_points = data.t4_points;
        adminProduct.t3_points = data.t3_points;
        adminProduct.t2_points = data.t2_points;
        adminProduct.t1_points = data.t1_points;
        adminProduct.t2_points_app = data.t2_points_app;
        adminProduct.t1_points_app = data.t1_points_app;
        adminProduct.t3_points_app = data.t3_points_app;
        adminProduct.t4_points_app = data.t4_points_app;
        adminProduct.t5_points_app = data.t5_points_app;
        adminProduct.t5_wash_1 = data.t5_wash_1;
        adminProduct.t4_wash_1 = data.t4_wash_1;
        adminProduct.t3_wash_1 = data.t3_wash_1;
        adminProduct.t2_wash_1 = data.t2_wash_1;
        adminProduct.t1_wash_1 = data.t1_wash_1;
        adminProduct.t5_wash_2 = data.t5_wash_2;
        adminProduct.t4_wash_2 = data.t4_wash_2;
        adminProduct.t3_wash_2 = data.t3_wash_2;
        adminProduct.t2_wash_2 = data.t2_wash_2;
        adminProduct.t1_wash_2 = data.t1_wash_2;
        adminProduct.t5_wash_3 = data.t5_wash_3;
        adminProduct.t4_wash_3 = data.t4_wash_3;
        adminProduct.t3_wash_3 = data.t3_wash_3;
        adminProduct.t2_wash_3 = data.t2_wash_3;
        adminProduct.t1_wash_3 = data.t1_wash_3;
        adminProduct.t5_wash_4 = data.t5_wash_4;
        adminProduct.t4_wash_4 = data.t4_wash_4;
        adminProduct.t3_wash_4 = data.t3_wash_4;
        adminProduct.t2_wash_4 = data.t2_wash_4;
        adminProduct.t1_wash_4 = data.t1_wash_4;
        adminProduct.t1_wash_8 = data.t1_wash_8;
        adminProduct.t2_wash_8 = data.t2_wash_8;
        adminProduct.t3_wash_8 = data.t3_wash_8;
        adminProduct.t4_wash_8 = data.t4_wash_8;
        adminProduct.t5_wash_8 = data.t5_wash_8;
        adminProduct.aena_pvp_1 = data.aena_pvp_1;
        adminProduct.aena_pvp_2 = data.aena_pvp_2;
        adminProduct.aena_pvp_3 = data.aena_pvp_3;
        adminProduct.aena_pvp_4 = data.aena_pvp_4;
        adminProduct.aena_pvp_5 = data.aena_pvp_5;
        adminProduct.aena_pvp_6 = data.aena_pvp_6;
        adminProduct.aena_pvp_7 = data.aena_pvp_7;
        adminProduct.aena_pvp_8 = data.aena_pvp_8;
        adminProduct.aena_days = data.aena_days;
        adminProduct.id_provider = data.id_provider;
        adminProduct.num_options = data.num_options;
        adminProduct.id_rsys_2 = data.id_rsys_2;
        adminProduct.id_rsys_3 = data.id_rsys_3;
        adminProduct.is_active = data.is_active;
        adminProduct.only_internal = data.only_internal;
        adminProduct.type = data.type;
        adminProduct.lat = data.lat;
        adminProduct.lng = data.lng;
        adminProduct.name_es = data.name_es;
        adminProduct.name_en = data.name_en;
        adminProduct.name_ca = data.name_ca;
        adminProduct.name_fr = data.name_fr;
        adminProduct.required_space_number = data.required_space_number;
        adminProduct.required_calle = data.required_calle;
        adminProduct.t1_day_opt_1 = data.t1_day_opt_1;
        adminProduct.t1_day_opt_2 = data.t1_day_opt_2;
        adminProduct.t1_day_opt_3 = data.t1_day_opt_3;
        adminProduct.t2_day_opt_1 = data.t2_day_opt_1;
        adminProduct.t2_day_opt_2 = data.t2_day_opt_2;
        adminProduct.t2_day_opt_3 = data.t2_day_opt_3;
        adminProduct.t3_day_opt_1 = data.t3_day_opt_1;
        adminProduct.t3_day_opt_2 = data.t3_day_opt_2;
        adminProduct.t3_day_opt_3 = data.t3_day_opt_3;
        adminProduct.t4_day_opt_1 = data.t4_day_opt_1;
        adminProduct.t4_day_opt_2 = data.t4_day_opt_2;
        adminProduct.t4_day_opt_3 = data.t4_day_opt_3;
        adminProduct.t5_day_opt_1 = data.t5_day_opt_1;
        adminProduct.t5_day_opt_2 = data.t5_day_opt_2;
        adminProduct.t5_day_opt_3 = data.t5_day_opt_3;
        adminProduct.keys_required_sometimes = data.keys_required_sometimes;
        adminProduct.out_of_stock_message_es = data.out_of_stock_message_es;
        adminProduct.out_of_stock_message_en = data.out_of_stock_message_en;
        adminProduct.out_of_stock_message_ca = data.out_of_stock_message_ca;
        adminProduct.out_of_stock_message_fr = data.out_of_stock_message_fr;
        return adminProduct;
    }
    static buildAdminProductInfo(data) {
        const adminProductInfo = new AdminProductInfo();
        const { info } = data;
        adminProductInfo.id = info.id;
        adminProductInfo.id_lot = info.id_lot;
        adminProductInfo.id_product = info.id_product;
        adminProductInfo.place_id = info.place_id;
        adminProductInfo.provider = info.provider;
        adminProductInfo.service = info.service;
        adminProductInfo.lat = info.lat;
        adminProductInfo.lng = info.lng;
        adminProductInfo.contact_email = info.contact_email;
        adminProductInfo.contact_phone = info.contact_phone;
        adminProductInfo.product_address = info.product_address;
        adminProductInfo.service_info_es = _.map(info.service_info_es, (service_info_es) => {
            return ProductBuilder.buildInfoSection(service_info_es);
        });
        adminProductInfo.service_info_ca = _.map(info.service_info_ca, (service_info_ca) => {
            return ProductBuilder.buildInfoSection(service_info_ca);
        });
        adminProductInfo.service_info_en = _.map(info.service_info_en, (service_info_en) => {
            return ProductBuilder.buildInfoSection(service_info_en);
        });
        adminProductInfo.service_info_fr = _.map(info.service_info_fr, (service_info_fr) => {
            return ProductBuilder.buildInfoSection(service_info_fr);
        });
        adminProductInfo.short_description_es = info.short_description_es;
        adminProductInfo.short_description_ca = info.short_description_ca;
        adminProductInfo.short_description_en = info.short_description_en;
        adminProductInfo.short_description_fr = info.short_description_fr;
        adminProductInfo.icon = info.icon;
        adminProductInfo.image_gallery = info.image_gallery ? ImageGalleryBuilder.buildImageGallery(info.image_gallery) : null;
        return adminProductInfo;
    }
}
//# sourceMappingURL=adminProduct-builder.js.map